import React, { Component } from 'react'
import NamezzzSlider from './NamezzzSlider'
import { getTranslation } from '../Utilities/GetTranslation.js'

class NamezzzLanguage extends Component {
    constructor (props) {
        super(props)
        this.handleValueChange = this.handleValueChange.bind(this)
    }

    handleValueChange (id, e) {
        this.props.onLanguageChange(this.props.id, id, e)
    }

    handleDelete (id, e) {
        e.preventDefault()
        this.props.onLanguageDelete(id)
    }

    componentDidMount () {

    }

    componentWillUnmount () {

    }

    render () {
        return (
            <li>
                <div>
                    <i className="fa fa-comments"></i> {this.props.language}
                    {
                        (this.props.delete)
                            ? <a href="# " onClick={(e) => this.handleDelete(this.props.id, e)}><span className="sr-only">{getTranslation("sns.general.screenreader.delete")}</span><i className="fa fa-trash-o" aria-hidden="true"></i></a>
                            : ''
                    }
                </div>
                <ul className="sliders">
                    <NamezzzSlider id="talk" text={getTranslation('sns.webparts.capabilities.languages.talk')} delete={false} value={this.props.talk} onChange={this.handleValueChange} />
                    <NamezzzSlider id="read" text={getTranslation('sns.webparts.capabilities.languages.read')} delete={false} value={this.props.read} onChange={this.handleValueChange} />
                    <NamezzzSlider id="write" text={getTranslation('sns.webparts.capabilities.languages.write')} delete={false} value={this.props.write} onChange={this.handleValueChange} />
                </ul>
            </li>
        )
    }
}

export default NamezzzLanguage



// WEBPACK FOOTER //
// ./src/Fields/NamezzzLanguage.js